const printEnvVars = () => {
    const { REACT_APP_SERVER_URL } = process.env;
    console.table({ REACT_APP_SERVER_URL });
};

export default printEnvVars;
